import fetch from "../utils/fetch";
//订单列表
export const fetchTakeOutList = (params) =>
  fetch(`/elemeOrder`, {
    params,
  });

//订单详情
export const fetchOrderDetail = (orderId) =>
  fetch(`/elemeOrder/detail/${orderId}`);
